import styled from 'styled-components'
import { COLOR } from '../../assets/constants/constants'

const { primary, secondary } = COLOR;

export const StyledSubTitle = styled.p`
  font-size: 14px;
`;

export const StyledSubTitleDiv = styled.div`
  padding-top: 7px;
  border-top: 1px solid ${secondary};
  display: flex;
  justify-content: space-between;
  cursor: pointer;

  &:hover {
    color: ${primary};
    border-top: 1px solid ${primary};
  }
`;
